// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"59578bc0","453":"d938a51a","863":"9e5f0031"}[chunkId] + ".chunk.js";
};